/* tslint:disable */
/* eslint-disable */
/**
 * Document API
 * API for managing documents
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the DocumentUploadUrlResponse interface.
 */
export function instanceOfDocumentUploadUrlResponse(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('documentId' in value) || value['documentId'] === undefined)
        return false;
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('expiresIn' in value) || value['expiresIn'] === undefined)
        return false;
    if (!('contentType' in value) || value['contentType'] === undefined)
        return false;
    return true;
}
export function DocumentUploadUrlResponseFromJSON(json) {
    return DocumentUploadUrlResponseFromJSONTyped(json, false);
}
export function DocumentUploadUrlResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'documentId': json['documentId'],
        'key': json['key'],
        'expiresIn': json['expiresIn'],
        'contentType': json['contentType'],
    };
}
export function DocumentUploadUrlResponseToJSON(json) {
    return DocumentUploadUrlResponseToJSONTyped(json, false);
}
export function DocumentUploadUrlResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'documentId': value['documentId'],
        'key': value['key'],
        'expiresIn': value['expiresIn'],
        'contentType': value['contentType'],
    };
}
